import api from '@/shared/utils/api';

export interface UserProfile {
  staff_id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  role: string;
  is_active: boolean;
  created_at: string;
  department?: {
    department_id: string;
    department_name: string;
  };
}

export interface UpdateProfileData {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
}

export interface ChangePasswordData {
  current_password: string;
  new_password: string;
}

export const userService = {
  getProfile: () => api.get<UserProfile>('/profile'),

  updateProfile: (data: UpdateProfileData) =>
    api.put<{ message: string; staff: UserProfile }>('/profile/update', data),

  changePassword: (data: ChangePasswordData) =>
    api.post<{ message: string }>('/profile/change-password', data),
};
